module.exports = "/packs/images/homepage/facilities/safety_in_our_libraries~d41805005bff9201667d4044ab7a59e7.jpg";